import Vue from "vue";
import Router from "vue-router";
import Cookie from "js-cookie";
import Home from "@/pages/Home";
import index from "@/pages/index";
import detail from "@/pages/detail";
import wecome from "../pages/wecome/wecome";
Vue.use(Router);

var router = new Router({
  routes: [
    //重定向
    {
      path: "/",
      redirect: "/wecome"
    },
    {
      path: "/wecome",
      component: wecome
    },
    {
      path: "/home",
      component: Home,
      children: [
        {
          path: "/index",
          component: index,
          name: "首页"
        },
        {
          path: "/detail",
          component: detail,
          name: "详情"
        }
      ]
    }
  ]
});
router.beforeEach((to, form, next) => {
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js